import { concat, of } from 'rxjs'
import { map, publishReplay, refCount, catchError } from 'rxjs/operators'
import {
  createClearLoading$,
  createLoading$,
  clearLoading$,
} from '@apiEnabler/api-enabler-common/lib/loading'
import { createErrorWithType } from '@apiEnabler/api-enabler-common/lib/errors'
import {
  setCustomerType,
  setCustomerDetails,
} from '@apiEnabler/ob-common/lib/customer'

import { getCustomerDetails$ } from './services'

const recoverCustomerNotFound = error => {
  if (error.type === 'not-found') {
    return concat(
      of(state =>
        state.set(
          'error',
          createErrorWithType('Customer not found', 'customer-not-found')
        )
      ),
      clearLoading$
    )
  }
  throw error
}

export const initialData$ = concat(
  createLoading$('Loading initial data'),
  getCustomerDetails$.pipe(
    map(setCustomerType('pbb')),
    map(setCustomerDetails),
    catchError(recoverCustomerNotFound)
  ),
  createClearLoading$('Loading initial data')
).pipe(publishReplay(1), refCount())
